'use strict';

var $ = window.$;

var mediaXs = 320;
var mediaSm = 480;
var mediaMd = 768;
var mediaLg = 1024;
var mediaXl = 1280;
var mediaXxl = 1440;

var lastScrollTop = 0;

function toggleContent() {
  var buttonSelector = '.js__toggle-btn';
  var buttonMod = 'active';
  var contentSelector = '.js__toggle-content';
  var blockSelector = '.js__toggle-block';
  var itemSelector = '.js__toggle-item';

  $(document).on('click', buttonSelector, function(){
    var $block = $(this).closest(blockSelector);
    var $button = $block.find(buttonSelector);
    var $currentItem = $(this).closest(itemSelector);
    var $content = $block.find(contentSelector);
    var mediaMax = $block.data('toggle-max') || Infinity;
    var mediaMin = $block.data('toggle-min') || 0;
    var isMultiToggle = $block.data('toggle-multitoggle');
    var windowWidth = $(window).width();
    if (windowWidth < mediaMax && windowWidth > mediaMin) {
      if ($currentItem.length) {
        var $currentContent = $currentItem.find(contentSelector);
      } else {
        var $currentContent = $content;
      }
      if (isMultiToggle !== undefined) {
        $content.not($currentContent).hide();
        $button.not(this).removeClass(buttonMod);
      }
      $currentContent.toggle();
      $(this).toggleClass(buttonMod);
    }
  });
}

function sliderAlign(slider) {
  $(slider).each(function(){
    var slickTrack = $(this).find('.slick-track');
    slickTrack.css('height', 'auto');
    var sliderHeight = slickTrack.height();
    slickTrack.css('height', sliderHeight + 'px');
  });
}

function mobileHeaderBehavior() {
  var $header = $('.page__header');
  var $warning = $('.page__warning');
  var headerHiddenClass = 'page__header_mobile-hidden';
  var warningHiddenClass = 'page__warning_mobile-header-hidden';

  if ($(window).width() < mediaXl) {
    var scrollTop = $(window).scrollTop();

    if (scrollTop === 0) {
      $header.removeClass(headerHiddenClass);
      $warning.removeClass(warningHiddenClass);
    } else if (scrollTop > lastScrollTop) {
      // scroll down
      $header.addClass(headerHiddenClass);
      $warning.addClass(warningHiddenClass);
    } else {
      // scroll up
      $header.removeClass(headerHiddenClass);
      $warning.removeClass(warningHiddenClass);
    }
    lastScrollTop = scrollTop;
  }
}

function initPartnersOfferSlider() {
  var slider = $('.partners-offer-slider__init');
  function checkIsInit() {
    if (slider.hasClass('slick-initialized')) {
      slider.slick('unslick');
    }
  };
  if ($(window).width() > mediaXxl) {
    checkIsInit();
    slider.slick({
      // autoplay: true,
      arrows: false,
      slidesToShow: 3,
    });
  } else if ($(window).width() > mediaMd) {
    checkIsInit();
    slider.slick({
      // autoplay: true,
      arrows: false,
      slidesToShow: 2,
    });
  } else {
    checkIsInit();
  }
}

$(document).ready(function () {

  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.buttons = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.touch = false;
  $.fancybox.defaults.smallBtn = false;

  $(document).on('click', '.js__close-btn', function(){
    $(this).closest('.js__close-block').hide();
  });

  mobileHeaderBehavior();

  $(document).on('afterShow.fb', function (e, instance, slide) {
    var $container = $('.fancybox-content .has-scrollbar');
    if($container.getNiceScroll && $container.getNiceScroll().length > 0) $container.getNiceScroll().resize();
    else initNiceScroll($container);
  });

  $.datepicker.setDefaults( $.datepicker.regional[ "ru" ] );

  // Отправка формы на главной
  $('#requestForm').on('submit', function(e) {


    e.preventDefault();

    $('[data-remodal-id="modal-success"]').remodal().open();

    // $.ajax({
    //   url:     "/send_form/main-sender.php", //url страницы
    //   type:     "POST", //метод отправки
    //   dataType: "html", //формат данных
    //   data: $(this).serialize(),

    //   success: function(response) { //Данные отправлены успешно
    //     console.log('+');
    //   },
    //   error: function(response) { // Данные не отправлены
    //     console.log('-');
    //   }
    // })
  });

  /* start mask for phones */
  // window.VMasker(document.querySelectorAll('input[name=phone]')).maskPattern('+9 (999) 999-9999');

  $('input[name=phone]').on('click', function(){
      if ( $(this).val() === '') {
          $(this).val('+7');
      }
  });

  /* end mask for phones */

  // Открытие мобильного меню
  $('.js-openMenu').on('click', function(e){
    $(this).toggleClass('isOpen');
    $('#mobileMenu').toggleClass('isOpen');

  });

  $('body').on('click', function(e){
    var menuButton = $('.js-openMenu');
    var mobileMenu = $('#mobileMenu');
    if (!menuButton.is(e.target) && menuButton.has(e.target).length === 0 && !mobileMenu.is(e.target) && mobileMenu.has(e.target).length === 0) {
      $('.js-openMenu').removeClass('isOpen');
      $('#mobileMenu').removeClass('isOpen');
    }
  });


  // dropDown меню

  $('.js-dropDown').on('click', function(){
    $(this).toggleClass('isOpen');
    $(this).siblings('.dropDownMenu__content').slideToggle(200);
  });


  // Фиксированное меню

  if ($(window).width() > 1024 && $('section').is('#calcBlock')) {
    var lastScrollTop = 0;
    var wrapper = $('.awPageWrapper');
    var fixedDashboard = $('#headDashboard');
    var calcBlockPos = $('#calcBlock').offset().top;
    var calcBlockHeight = $('#calcBlock').height();

    $(window).scroll(function(event){
      var st = $(this).scrollTop();

      if (st > fixedDashboard.height() + 100 && st < calcBlockPos + calcBlockHeight + 200) {
        fixedDashboard.addClass('isFirst');
      } else {
        fixedDashboard.removeClass('isFirst');
      }

      if (st > calcBlockPos + calcBlockHeight) {
        wrapper.addClass('awPageWrapper_fixedDashboard');
        fixedDashboard.addClass('isShow');

        if (st > lastScrollTop){
          fixedDashboard.removeClass('isOpen');
        } else {
          fixedDashboard.addClass('isOpen');
        }
        lastScrollTop = st;
      } else {
        wrapper.removeClass('awPageWrapper_fixedDashboard');
        fixedDashboard.removeClass('isShow');
        fixedDashboard.removeClass('isOpen');
      }
    });
  } else if ($('div').is('#asideCalc')) {
    var calcAside = $('#asideCalc')
    var calcAsidePos = calcAside.offset().top;

    $(window).scroll(function(event){
      var st = $(this).scrollTop();
      if (st >= calcAsidePos) {
        calcAside.addClass('isFixed');
      } else {
        calcAside.removeClass('isFixed');
      }
    });
  }


  $("body").on("click",".js-upper", function (event) {
    $('html, body').animate({scrollTop: 0}, 700);
  });

  // Селект
  window.customselect = new CheckboxToSelect('.js__tabselect');

  // Табы
  $(document).delegate('.js__tabs [data-button]', 'click', function(e){
    e.preventDefault();
    var $container = $(this).closest('.js__tabs');
    var index = $(this).data('button');

    $('[data-button]', $container).removeClass('active');
    $('[data-button=' + index + ']', $container).addClass('active');
    $('[data-tab]', $container).removeClass('active');
    $('[data-tab=' + index + ']', $container).addClass('active');

    pageFullHeight();
  });

  // Датапикер
  $(".js__datepicker").datepicker({
    firstDay: 1,
  });

  // $(".js__datepicker").each(function(){
  //   $(this).datepicker({
  //     firstDay: 1,
  //   });
  // });

  // Кастомный скроллбар
  window.initNiceScroll = function(selector) {
    var $container = selector instanceof jQuery ? selector:$(selector);
    $container.niceScroll({
      cursorwidth: 6,
      cursorborderradius: '3px',
      cursorcolor: '#A1A4B1',
      cursorborder: 'none',
      background: "#E7EAEF"
    });
  };
  window.initNiceScroll(".has-scrollbar");

  // Открыть меню
  $(document).on('click', '.js__open-menu', function(){
    $('.page').addClass('page_overflow_hidden');
    $('.page__sidebar').addClass('page__sidebar_open');
    $('.page__menu-overlay').addClass('page__menu-overlay_open');
    $('.page__menu-overlay').show();
    $('.page__menu-overlay').animate({opacity: 0.6}, 400);
    setTimeout(function(){
      $('.page__sidebar').getNiceScroll().resize()
    }, 400);
  });

  // Закрыть меню
  $(document).on('click', '.js__close-menu', function(){
    $('.page').removeClass('page_overflow_hidden');
    $('.page__sidebar').removeClass('page__sidebar_open');
    $('.page__menu-overlay').animate({opacity: 0}, 400);
    setTimeout(function(){
      $('.page__menu-overlay').hide();
      $('.page__sidebar').getNiceScroll().resize()
    }, 400);
  });

  // Баннер-слайдер
  $('.banner_slider .banner__init').on("init afterChange", function(event, slick, currentSlide){
    var $block = $(this).closest('.banner_slider');
    $block.find(".slider-counter__current").text(slick.currentSlide + 1);
    $block.find(".slider-counter__total").text(slick.slideCount);
  }).slick({
    // autoplay: true,
    dots: true,
    useTransform: false,
    appendArrows: $('.banner__arrows'),
    appendDots: $('.banner__dots'),
  });

  $('.special-offer-slider__init').slick({
    // autoplay: true,
    // mobileFirst: true,
    arrows: false,
    slidesToShow: 4,
    responsive: [
    {
      breakpoint: mediaXxl,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: mediaMd,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: mediaSm,
      settings: {
        slidesToShow: 1,
      }
    },
  ]
  });

  initPartnersOfferSlider();

  $('.js__tooltip').tooltipster({
    theme: 'tooltip',
    minWidth: 200,
    maxWidth: 200,
    distance: -8,
    side: 'right',
    functionPosition: function(instance, helper, position){
        position.coord.top += -40;
        return position;
    },
  });

  $(document).on('click', '.js__open-search', function() {
    $('.header__search').slideDown();
  });

  $(document).on('click', '.js__close-search', function() {
    $('.header__search').slideUp();
  });

  $(document).on('click', '.js__close-warning', function() {
	$(this).closest('.warning').remove();
  });

  $(document).on('click', '.js__modal-show-success', function(){
    var $block = $(this).closest('.js__modal');
    $block.find('.js__modal-form').hide();
    $block.find('.js__modal-success').show();
    setTimeout(function(){
      $.fancybox.close();
    }, 1500);
  });

  toggleContent();

  $('.js__change-placeholder-switch input').on('change', function(){
    var $block = $(this).closest('.js__change-placeholder-block');
    var $input = $block.find('.js__change-placeholder-input');
    var placeholder = $(this).closest('[data-placeholder]').data('placeholder');
    $input.attr('placeholder', placeholder);
  })

  $(document).on('click', '.select__button', function(){
    var $block = $(this).closest('.select');
    window.initNiceScroll($block.find('.select-has-scrollbar'));
  });

  $(document).on('click', '.content__close-btn', function(){
    $(this).closest('.content').hide();
  });




  // Слайдеры
  // var fixHeightElements = function (el) {
  //   var elementsToFixHeight = el.find('.lslide');
  //   var myArr = [];
  //   $.each($(elementsToFixHeight), function (index, item) {
  //     myArr.push($(item).innerHeight());
  //   });
  //   var maxHeight = Math.max.apply(null, myArr);
  //   el.css('min-height', maxHeight + 5 + 'px');
  //   elementsToFixHeight.css('height', maxHeight + 5 + 'px');
  // };

  // var customTogglers = function (el) {
  //   var sliderOuter = el.parents('.slider__outer');
  //   var togglerLeft = sliderOuter.find('.slider__toggler_left');
  //   var togglerRight = sliderOuter.find('.slider__toggler_right');
  //   togglerLeft.click(function () {
  //     el.goToPrevSlide();
  //   });
  //   togglerRight.click(function () {
  //     el.goToNextSlide();
  //   });
  // };

  // var checkSlidesLength = function (el) {
  //   var slidesLenght = el.find('.slider__item').length;
  //   var slidesWidth = el.find('.slider__item').width();
  //   var outherWidth = el.parents('.slider__outer').width();
  //   var slidesQuantity = Math.round(outherWidth/slidesWidth)

  //   if (slidesQuantity >= slidesLenght) {
  //     el.parents('.slider__outer').addClass('slider__outer_underMinimal');
  //     slider.destroy();
  //   } else {
  //     el.parents('.slider__outer').addClass('slider__outer_arrow');
  //   }
  // };


  // $('.js_defaultSlider').lightSlider({
  //     item: 2,
  //     slideMargin: 40,
  //     speed: 700,
  //     pager: false,
  //     loop:false,
  //     enableDrag: false,
  //     controls: false,
  //     slideMove: 1,
  //     easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
  //     responsive : [
  //         {
  //             breakpoint:1024,
  //             settings: {
  //                 item:2,
  //               }
  //         },
  //         {
  //             breakpoint:768,
  //             settings: {
  //                 item:2,
  //               }
  //         },
  //         {
  //             breakpoint:480,
  //             settings: {
  //                 item:1,
  //               }
  //         }
  //     ],
  //     onSliderLoad: function(el) {
  //         customTogglers(el);


  //         var elementsToFixHeight = el.find('.lslide');
  //         var myArr = [];
  //         $.each( $(elementsToFixHeight), function( index, item ) {
  //             myArr.push($(item).innerHeight())
  //         });
  //         var maxHeight = Math.max.apply(null, myArr);
  //         el.css({'height': maxHeight + 5 + 'px'});
  //         el.find('.lslide').show();
  //         checkSlidesLength(el);
  //       }
  //   });

  //   $('.js_reviewsSlider').lightSlider({
  //     item: 2,
  //     slideMargin: 60,
  //     speed: 700,
  //     pager: true,
  //     loop:false,
  //     enableDrag: false,
  //     controls: false,
  //     slideMove: 1,
  //     easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
  //     responsive : [
  //         {
  //             breakpoint:480,
  //             settings: {
  //                 item:1,
  //               }
  //         }
  //     ],
  //     onSliderLoad: function(el) {
  //         customTogglers(el);


  //         var elementsToFixHeight = el.find('.lslide');
  //         var myArr = [];
  //         $.each( $(elementsToFixHeight), function( index, item ) {
  //             myArr.push($(item).innerHeight())
  //         });
  //         var maxHeight = Math.max.apply(null, myArr);
  //         el.css({'height': maxHeight + 5 + 'px'});
  //         el.find('.lslide').show();
  //         checkSlidesLength(el);
  //       }
  //   });

});

$(window).on('load', function() {
  sliderAlign('.special-offer-slider__init');
  sliderAlign('.partners-offer-slider__init');
  sliderAlign('.banner_slider .banner__init');
});

$(window).on('resize', function() {
  initPartnersOfferSlider();
  sliderAlign('.special-offer-slider__init');
  sliderAlign('.partners-offer-slider__init');
  sliderAlign('.banner_slider .banner__init');
  mobileHeaderBehavior();
});

$(window).on('scroll', function() {
  mobileHeaderBehavior();
});
